__turbopack_context__.v({
  "item": "style-module-scss-module__vhOGDa__item",
  "nav": "style-module-scss-module__vhOGDa__nav",
  "profile": "style-module-scss-module__vhOGDa__profile",
  "search": "style-module-scss-module__vhOGDa__search",
  "subMenu": "style-module-scss-module__vhOGDa__subMenu",
});
